/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Custom_ImportInputs */



/**
* | output |
* | --- |
* | "Custom Data Import (.JSON, and .CSV)" |
*
* @param {Signup_Compare_Custom_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_custom_import = /** @type {((inputs?: Signup_Compare_Custom_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Custom_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Custom Data Import (.JSON, and .CSV)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Custom Data Import (.JSON, and .CSV)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Custom Data Import (.JSON, and .CSV)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Custom Data Import (.JSON, and .CSV)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Custom Data Import (.JSON, and .CSV)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Custom Data Import (.JSON, and .CSV)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Custom Data Import (.JSON, and .CSV)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Custom Data Import (.JSON, and .CSV)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Custom Data Import (.JSON, and .CSV)")
	return /** @type {LocalizedString} */ ("Custom Data Import (.JSON, and .CSV)")
});